import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import TrustSection from '../components/TrustSection';
import About from '../components/About';
import Story from '../components/Story';
import Services from '../components/Services';
import WebDesignPackages from '../components/WebDesignPackages';
import Testimonials from '../components/Testimonials';
import Portfolio from '../components/Portfolio';
import CaseStudies from '../components/CaseStudies';
import Pricing from '../components/Pricing';
import WhyWorkWithMe from '../components/WhyWorkWithMe';
import Blog from '../components/Blog';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Header />
      <main>
        <Hero />
        <TrustSection />
        <About />
        <Story />
        <Services />
        <Portfolio />
        <CaseStudies />
        <Pricing />
        <WebDesignPackages />
        <WhyWorkWithMe />
        <Blog />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
